// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f65c4ae7","49":"4b7c7de9","455":"e8fefc00","829":"2914137d","856":"ceb07f1f"}[chunkId] + ".chunk.js";
};